import { render } from "./MaterialsServers.vue?vue&type=template&id=44faa2d0"
import script from "./MaterialsServers.vue?vue&type=script&lang=js"
export * from "./MaterialsServers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__